import { Action, Dispatch, Middleware, MiddlewareAPI } from 'redux';

const identity = (x) => x;

interface Options {
    actionTransformer?: (action: Action) => any;
    stateTransformer?: (state: any) => any;
    breadcrumbCategory?: string;
}

export function createRavenMiddleware(Raven, options: Options = {}): Middleware {
    const {
        actionTransformer = identity,
        stateTransformer = identity,
        breadcrumbCategory = 'redux-action',
    } = options;

    return <S>(api: MiddlewareAPI<S>) => {
        // Record the initial state in case we crash before the first action
        // succeeds.
        Raven.setExtraContext({state: stateTransformer(api.getState())});

        return (next: Dispatch<S>) => <A extends Action>(action: A): A => {
            // Log the action taken to Raven so that we have narrative context in our
            // error report.
            Raven.captureBreadcrumb({
                category: breadcrumbCategory,
                message: action.type,
            });

            // Set the action as context in case we crash in the reducer.
            Raven.context({lastAction: actionTransformer(action)}, () =>
                next(action));

            // Set the last action and state as context in case we crash before
            // the next action is dispatched.
            Raven.setExtraContext({
                lastAction: actionTransformer(action),
                state: stateTransformer(api.getState()),
            });

            // FIXME CeMi: povodne to return nebol, ale ts hlasi chybu. Mozno tu ma byt return next(action) ?
            return undefined;
        };
    };
}
